/**
 * Renders a "Call (518) 900-1913" style label safely in right-to-left pages.
 *
 * Without isolation, Arabic/Urdu layout reorders the number's segments
 * ("(518) 900-1913" becomes "1913-900 (518)"). Wrapping the number in an
 * LTR <bdi> keeps it readable while the surrounding words stay RTL.
 */
const PHONE = "(518) 900-1913";

export function CallLabel({ label }: { label: string }) {
  const at = label.indexOf(PHONE);
  if (at === -1) return <>{label}</>;
  return (
    <>
      {label.slice(0, at)}
      <bdi dir="ltr">{PHONE}</bdi>
      {label.slice(at + PHONE.length)}
    </>
  );
}